// The home page controller (ARCHITECTURE §5.2). Registered by
// core/pages/controllers.ts; classic's Home view consumes its VM.
import { useMemo } from 'react'
import { useLabels } from '../../labels'
import { useOptionalSiteTemplate } from '../../template/hostContext'
import { defaultHomeDivision } from '../../template/types'
import { homeDefaultTitles } from './derive'
import { useHomePage } from './useHomePage'

export default function useHomeController() {
  const t = useLabels()
  // Section defaults (league overrides still win in derive's sectionTitle()).
  // `t` changes with the language, so the defaults follow it.
  const titles = useMemo(() => ({ ...homeDefaultTitles(), upcoming: t.ui.home.upcomingTitle }), [t])
  // #583: a template without a Home division switcher (Classic) sets
  // pageDefaults.homeDivision = 'all'; the rest follow the fan's pick.
  const division = defaultHomeDivision(useOptionalSiteTemplate()?.manifest)
  return useHomePage(titles, { division })
}
